import styled from 'styled-components';
import { OpenNewWindow16 } from 'ui/icons';
import { Radio } from 'ui/radio';
import { body2, colors, fontSizes, fontWeights, spacing, zIndex } from 'ui/theme';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';
import { pxToRem } from 'utils/convert';

export const SelectiveTargetingSection = styled.div`
  width: 100%;
`;

export const AppsListPreview = styled.div`
  margin-top: ${spacing.half};
  margin-left: ${spacing.threeQuarter};
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  border: none;
  padding: ${pxToRem(10)} ${spacing.threeQuarter};
  background-color: transparent;
`;

export const TriggerPreview = styled.span`
  display: flex;
  gap: ${spacing.quarter};
  ${body2}
`;

export const AppsCounter = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.purple100};
  color: white;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
`;

export const StyledDropdownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusQuarter};
  padding: ${spacing.base};
`;

export const RadioRow = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: flex-start;
`;

export const StyledRadio = styled(Radio)`
  margin-top: ${spacing.eighth};
  min-width: ${spacing.plusQuarter};
`;

export const TargetingOptionLabel = styled.div`
  display: flex;
  font-weight: ${fontWeights.medium};
  margin-bottom: ${spacing.quarter};
`;

export const HelpIconContainer = styled.span`
  margin-left: ${spacing.quarter};
  margin-top: ${spacing.eighth};
`;

export const AppsListSubtextContainer = styled.div`
  font-size: ${fontSizes.s12};
`;

export const AppIconContainer = styled.span`
  position: relative;
  top: ${spacing.eighth};
  margin-right: ${spacing.quarter};
`;

export const AppsListSubtext = styled.span<{ color?: string }>`
  position: relative;
  ${({ color }) => color && `color: ${color};`}
`;

export const TooltipContainer = styled(AppsListSubtext)`
  color: ${colors.grey50};
`;

export const StyledTooltipContent = styled(TooltipContent)`
  z-index: ${zIndex.newDropdown};
`;

export const CustomListContainer = styled.div`
  margin-top: -${spacing.base};
`;

export const StyledLabel = styled.label`
  font-weight: ${fontWeights.regular};
  margin-top: ${spacing.quarter};
  overflow: hidden;
  max-width: ${pxToRem(320)};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyStateContainer = styled.div`
  color: ${colors.grey50};
`;

export const StyledOpenWindowIcon = styled(OpenNewWindow16)`
  position: relative;
  top: ${spacing.quarter};
  left: ${spacing.quarter};
`;
